(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    

(() => {

  const pages =
    document.querySelectorAll(
      '[data-sbc-editorial]:not([data-sbc-ready])'
    );


  pages.forEach((page) => {

    page.setAttribute(
      'data-sbc-ready',
      'true'
    );


    /* ========================================================
       SCROLL REVEALS
       ======================================================== */

    const revealItems =
      page.querySelectorAll(
        '[data-sbc-reveal]'
      );


    if (
      'IntersectionObserver' in window &&
      !window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {

      const observer =
        new IntersectionObserver(
          (entries) => {

            entries.forEach(
              (entry) => {

                if (
                  entry.isIntersecting
                ) {

                  entry.target.classList.add(
                    'is-visible'
                  );


                  observer.unobserve(
                    entry.target
                  );

                }

              }
            );

          },
          {
            threshold: .12
          }
        );


      revealItems.forEach(
        (item, index) => {

          item.style.transitionDelay =
            `${Math.min(index * 35, 210)}ms`;


          observer.observe(
            item
          );

        }
      );

    } else {

      revealItems.forEach(
        item =>
          item.classList.add(
            'is-visible'
          )
      );

    }



    /* ========================================================
       MOUSE DEPTH
       ======================================================== */

    const finePointer =
      window.matchMedia(
        '(hover: hover) and (pointer: fine)'
      );


    if (
      finePointer.matches
    ) {

      page
        .querySelectorAll(
          '.sbc-depth'
        )
        .forEach((element) => {

          element.addEventListener(
            'pointermove',
            (event) => {

              const rect =
                element.getBoundingClientRect();


              const x =
                (
                  event.clientX -
                  rect.left
                ) /
                Math.max(
                  rect.width,
                  1
                );


              const y =
                (
                  event.clientY -
                  rect.top
                ) /
                Math.max(
                  rect.height,
                  1
                );


              element.style.setProperty(
                '--sbc-x',
                ((x - .5) * 2).toFixed(3)
              );


              element.style.setProperty(
                '--sbc-y',
                ((y - .5) * 2).toFixed(3)
              );

            }
          );


          element.addEventListener(
            'pointerleave',
            () => {

              element.style.setProperty(
                '--sbc-x',
                '0'
              );


              element.style.setProperty(
                '--sbc-y',
                '0'
              );

            }
          );

        });

    }

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    

(() => {

  const productRoot =
    document.querySelector(
      '.product-information'
    );

  if (!productRoot) {
    return;
  }


  /* ========================================================
     HELPERS
     ======================================================== */

  function bestImageSource(img) {

    if (!img) {
      return '';
    }

    const srcset =
      img.getAttribute(
        'srcset'
      );

    if (srcset) {

      const candidates =
        srcset
          .split(',')
          .map((candidate) => {

            const parts =
              candidate
                .trim()
                .split(/\s+/);

            return {
              src:
                parts[0],

              width:
                parseInt(
                  parts[1],
                  10
                ) || 0
            };

          })
          .sort(
            (a, b) =>
              b.width -
              a.width
          );


      if (
        candidates[0]?.src
      ) {
        return candidates[0].src;
      }

    }


    return (
      img.currentSrc ||
      img.src ||
      ''
    );

  }



  function collectImages() {

    const seen =
      new Set();


    const images =
      [];


    document
      .querySelectorAll(
        `
        .product-information
        .product-information__media
        .product-media-container--image
        `
      )
      .forEach(
        (container) => {

          if (
            container.closest(
              '.dialog-zoomed-gallery'
            )
          ) {
            return;
          }


          const img =
            container.querySelector(
              'img'
            );


          if (!img) {
            return;
          }


          const source =
            bestImageSource(
              img
            );


          if (
            !source ||
            seen.has(source)
          ) {
            return;
          }


          seen.add(
            source
          );


          images.push({
            src: source,

            thumb:
              img.currentSrc ||
              img.src,

            alt:
              img.alt ||
              'SoulByChi'
          });

        }
      );


    return images;

  }



  /* ========================================================
     CREATE LIGHTBOX
     ======================================================== */

  const dialog =
    document.createElement(
      'dialog'
    );


  dialog.className =
    'sbc-pdp-lightbox';


  dialog.setAttribute(
    'aria-label',
    'Ürün görsel galerisi'
  );


  dialog.innerHTML = `

    <div
      class="sbc-pdp-lightbox__top"
    >

      <div
        class="sbc-pdp-lightbox__title"
        data-sbc-lightbox-title
      >
        SoulByChi
      </div>


      <div
        class="sbc-pdp-lightbox__count"
        data-sbc-lightbox-count
      >
        01 / 01
      </div>


      <button
        type="button"
        class="sbc-pdp-lightbox__close"
        data-sbc-lightbox-close
        aria-label="Galeriyi kapat"
      ></button>

    </div>


    <div
      class="sbc-pdp-lightbox__layout"
    >

      <div
        class="sbc-pdp-lightbox__thumbs"
        data-sbc-lightbox-thumbs
      ></div>


      <div
        class="sbc-pdp-lightbox__stage"
        data-sbc-lightbox-stage
      >

        <button
          type="button"
          class="
            sbc-pdp-lightbox__arrow
            sbc-pdp-lightbox__arrow--prev
          "
          data-sbc-lightbox-prev
          aria-label="Önceki görsel"
        >
          ←
        </button>


        <div
          class="sbc-pdp-lightbox__image-wrap"
        >

          <img
            class="sbc-pdp-lightbox__image"
            data-sbc-lightbox-image
            alt=""
          >

        </div>


        <button
          type="button"
          class="
            sbc-pdp-lightbox__arrow
            sbc-pdp-lightbox__arrow--next
          "
          data-sbc-lightbox-next
          aria-label="Sonraki görsel"
        >
          →
        </button>


        <div
          class="sbc-pdp-lightbox__hint"
        >
          Görsele tıklayarak detay görünümü
        </div>

      </div>

    </div>

  `;


  document.body.appendChild(
    dialog
  );



  const viewer =
    dialog.querySelector(
      '[data-sbc-lightbox-image]'
    );


  const thumbs =
    dialog.querySelector(
      '[data-sbc-lightbox-thumbs]'
    );


  const count =
    dialog.querySelector(
      '[data-sbc-lightbox-count]'
    );


  const title =
    dialog.querySelector(
      '[data-sbc-lightbox-title]'
    );


  const stage =
    dialog.querySelector(
      '[data-sbc-lightbox-stage]'
    );


  let items =
    [];


  let current =
    0;


  let lastFocused =
    null;


  let touchStartX =
    0;



  /* ========================================================
     PRODUCT TITLE
     ======================================================== */

  const productTitle =
    document.querySelector(
      '.product-information .product-details h1'
    );


  if (
    productTitle
  ) {

    title.textContent =
      productTitle.textContent.trim();

  }



  /* ========================================================
     THUMBNAILS
     ======================================================== */

  function buildThumbs() {

    thumbs.innerHTML =
      '';


    items.forEach(
      (item, index) => {

        const button =
          document.createElement(
            'button'
          );


        button.type =
          'button';


        button.className =
          'sbc-pdp-lightbox__thumb';


        button.setAttribute(
          'aria-label',
          `Görsel ${index + 1}`
        );


        const image =
          document.createElement(
            'img'
          );


        image.src =
          item.thumb;


        image.alt =
          '';


        button.appendChild(
          image
        );


        button.addEventListener(
          'click',
          () => {

            showImage(
              index
            );

          }
        );


        thumbs.appendChild(
          button
        );

      }
    );

  }



  /* ========================================================
     SHOW IMAGE
     ======================================================== */

  function showImage(index) {

    if (
      !items.length
    ) {
      return;
    }


    current =
      (
        index +
        items.length
      ) %
      items.length;


    dialog.classList.remove(
      'is-detail-zoom'
    );


    dialog.classList.add(
      'is-switching'
    );


    const item =
      items[current];


    window.setTimeout(
      () => {

        viewer.src =
          item.src;


        viewer.alt =
          item.alt;


        count.textContent =
          `${String(
            current + 1
          ).padStart(2, '0')} / ${String(
            items.length
          ).padStart(2, '0')}`;


        thumbs
          .querySelectorAll(
            '.sbc-pdp-lightbox__thumb'
          )
          .forEach(
            (
              thumb,
              thumbIndex
            ) => {

              thumb.classList.toggle(
                'is-active',
                thumbIndex ===
                  current
              );

            }
          );


        viewer.onload =
          () => {

            dialog.classList.remove(
              'is-switching'
            );

          };


        /*
          Cached image fallback.
        */

        if (
          viewer.complete
        ) {

          requestAnimationFrame(
            () => {

              dialog.classList.remove(
                'is-switching'
              );

            }
          );

        }

      },

      120
    );

  }



  /* ========================================================
     OPEN
     ======================================================== */

  function openLightbox(
    clickedContainer
  ) {

    items =
      collectImages();


    if (
      !items.length
    ) {
      return;
    }


    lastFocused =
      document.activeElement;


    const clickedImage =
      clickedContainer.querySelector(
        'img'
      );


    const clickedSource =
      bestImageSource(
        clickedImage
      );


    let index =
      items.findIndex(
        item =>
          item.src ===
          clickedSource
      );


    if (
      index < 0
    ) {
      index = 0;
    }


    buildThumbs();


    showImage(
      index
    );


    document.body.classList.add(
      'sbc-pdp-lightbox-open'
    );


    if (
      typeof dialog.showModal ===
      'function'
    ) {

      dialog.showModal();

    } else {

      dialog.setAttribute(
        'open',
        ''
      );

    }


    dialog
      .querySelector(
        '[data-sbc-lightbox-close]'
      )
      ?.focus();

  }



  /* ========================================================
     CLOSE
     ======================================================== */

  function closeLightbox() {

    dialog.classList.remove(
      'is-detail-zoom'
    );


    document.body.classList.remove(
      'sbc-pdp-lightbox-open'
    );


    if (
      typeof dialog.close ===
      'function'
    ) {

      dialog.close();

    } else {

      dialog.removeAttribute(
        'open'
      );

    }


    lastFocused?.focus?.();

  }



  /* ========================================================
     INTERCEPT PRODUCT IMAGE CLICK
     ======================================================== */

  document.addEventListener(
    'click',
    (event) => {

      const media =
        event.target.closest(
          `
          .product-information
          .product-information__media
          .product-media-container--image
          `
        );


      if (
        !media ||
        media.closest(
          '.dialog-zoomed-gallery'
        )
      ) {
        return;
      }


      /*
        Stop Horizon native zoom.
        Our SoulByChi viewer handles it.
      */

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      openLightbox(
        media
      );

    },

    true
  );



  /* ========================================================
     CONTROLS
     ======================================================== */

  dialog
    .querySelector(
      '[data-sbc-lightbox-close]'
    )
    .addEventListener(
      'click',
      closeLightbox
    );


  dialog
    .querySelector(
      '[data-sbc-lightbox-prev]'
    )
    .addEventListener(
      'click',
      () => {

        showImage(
          current - 1
        );

      }
    );


  dialog
    .querySelector(
      '[data-sbc-lightbox-next]'
    )
    .addEventListener(
      'click',
      () => {

        showImage(
          current + 1
        );

      }
    );



  /* ESCAPE */

  dialog.addEventListener(
    'cancel',
    (event) => {

      event.preventDefault();

      closeLightbox();

    }
  );



  /* KEYBOARD */

  document.addEventListener(
    'keydown',
    (event) => {

      if (
        !dialog.open
      ) {
        return;
      }


      if (
        event.key ===
        'ArrowRight'
      ) {

        showImage(
          current + 1
        );

      }


      if (
        event.key ===
        'ArrowLeft'
      ) {

        showImage(
          current - 1
        );

      }

    }
  );



  /* ========================================================
     DETAIL ZOOM
     ======================================================== */

  viewer.addEventListener(
    'click',
    () => {

      dialog.classList.toggle(
        'is-detail-zoom'
      );

    }
  );


  viewer.addEventListener(
    'pointermove',
    (event) => {

      if (
        !dialog.classList.contains(
          'is-detail-zoom'
        )
      ) {
        return;
      }


      const rect =
        viewer.getBoundingClientRect();


      const x =
        (
          event.clientX -
          rect.left
        ) /
        Math.max(
          rect.width,
          1
        );


      const y =
        (
          event.clientY -
          rect.top
        ) /
        Math.max(
          rect.height,
          1
        );


      viewer.style.setProperty(
        '--sbc-zoom-x',
        `${x * 100}%`
      );


      viewer.style.setProperty(
        '--sbc-zoom-y',
        `${y * 100}%`
      );

    }
  );



  /* ========================================================
     MOBILE SWIPE
     ======================================================== */

  stage.addEventListener(
    'touchstart',
    (event) => {

      touchStartX =
        event.changedTouches[0]
          .clientX;

    },

    {
      passive: true
    }
  );


  stage.addEventListener(
    'touchend',
    (event) => {

      const difference =
        event.changedTouches[0]
          .clientX -
        touchStartX;


      if (
        Math.abs(
          difference
        ) < 45
      ) {
        return;
      }


      if (
        difference < 0
      ) {

        showImage(
          current + 1
        );

      } else {

        showImage(
          current - 1
        );

      }

    },

    {
      passive: true
    }
  );



  /* ========================================================
     NORMAL PAGE MOUSE DEPTH
     ======================================================== */

  const finePointer =
    window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    );


  if (
    finePointer.matches
  ) {

    document.addEventListener(
      'pointermove',
      (event) => {

        const media =
          event.target.closest(
            `
            .product-information
            .product-information__media
            .product-media-container--image
            `
          );


        if (
          !media ||
          media.closest(
            '.dialog-zoomed-gallery'
          )
        ) {
          return;
        }


        const rect =
          media.getBoundingClientRect();


        const x =
          (
            event.clientX -
            rect.left
          ) /
          Math.max(
            rect.width,
            1
          );


        const y =
          (
            event.clientY -
            rect.top
          ) /
          Math.max(
            rect.height,
            1
          );


        media.style.setProperty(
          '--sbc-pdp-x',
          ((x - .5) * 2).toFixed(3)
        );


        media.style.setProperty(
          '--sbc-pdp-y',
          ((y - .5) * 2).toFixed(3)
        );

      },

      {
        passive: true
      }
    );


    document.addEventListener(
      'pointerout',
      (event) => {

        const media =
          event.target.closest(
            `
            .product-information
            .product-information__media
            .product-media-container--image
            `
          );


        if (
          !media
        ) {
          return;
        }


        if (
          event.relatedTarget &&
          media.contains(
            event.relatedTarget
          )
        ) {
          return;
        }


        media.style.setProperty(
          '--sbc-pdp-x',
          '0'
        );


        media.style.setProperty(
          '--sbc-pdp-y',
          '0'
        );

      },

      {
        passive: true
      }
    );

  }

})();


  } catch(e) { console.error(e); }
})();
})();
